import { Burger } from './burger.js';
import { initMenuNav } from './menu-nav.js';
const header = document.querySelector('[data-menu-mobile]');
const overlay = document.querySelector('[data-menu-close]');

const burger = new Burger('[data-menu-mobile]', '[data-menu-mobile-open]', overlay);
const burgerCatalog = new Burger('[data-menu-catalog]', '[data-menu-catalog-open]', overlayCatalog);
const overlayCatalog = document.querySelector('[data-menu-overlay]');

const startMenu = () => {
  burger.init();
  burgerCatalog.init();
};

const closeMenu = () => {
  burger._closeMenu();
  burgerCatalog._closeMenu();
};

export const initMenu = function () {
  if (!header) {
    return;
  }

  startMenu();
  initMenuNav();
  closeMenu();

};
